import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, isNotEmpty } from '../../lib/ep';
import { useOwner } from '../context/context';

import ActionLink from '../builder/ActionLink';
import { Checkbox } from '../builder/Checkbox';
import FloatingLayer from '../builder/FloatingLayer';
import SectionTitle from '../builder/SectionTitle';

import PromoShareLayer from './PromoShareLayer';

import { ProfileModule } from '../ui_items/Module.js';
import ActivatePromoButton from '../backend/elements/ActivatePromoButton.js';

const ToDoList = (props) => {
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	const promotionType = owner?.promotion?.PromotionType ?? false;	// must use useOwner() instead of window.owner_main_vars
	const status = owner?.status ?? 'draft';

	const [ display_instructions_layer, setDisplayInstructionsLayer ] = useState(false);
	const [ display_share_layer, setDisplayShareLayer ] = useState(false);
	const [ progress_checkboxes, setProgressCheckboxes ] = useState(promotion?.config?.progress ?? {});

	if(promotion === false) return null;

	const is_basic = ((promotion?.promo_type ?? '0') == '0') ? true : false;

	const is_multi_participation = ((promotion?.multi_participation ?? '0') == '1') ? true : false;
	const is_multistage = (Object.keys(props?.stages ?? {}).length == 1) ? true : false;

	let to_do_actions = [];
	switch(status) {
		case 'active':
			to_do_actions = [{
				key:'preview',
				label:"Review before sharing",
				target:'_blank',
				url:`${window.public_url}p/${promotion.id}`,
			}, {
				key:'share',
				label:"Share on your social networks",
				action:() => setDisplayShareLayer(true),
			}, {
				key:'recommendations',
				label:"Read the publishing recommendations",
				target:'_blank',
				url:`${window.blog_base_url}${(window.is_spanish) ? 'como-difundir-una-campana-online-para-cumplir-los-objetivos-de-marketing/' : 'en/how-to-promote-online-campaigns/'}?utm_source=easypromos&utm_medium=profile`,
			}];
			break;

		case 'old':
		case 'expired':
			to_do_actions = [{
				key:'tutorial_closed',
				label:"Review the tutorial on how to close the promotion",
				target:'_blank',
				url:`${window.zendesk_base_url}207884106`,
			}, {
				key:'winners',
				label:"Assign the prize to the winners",
				url:getRemotedbUrl(`/prizes/manager/${promotion.id}`),
			}, {
				key:'publish_winners',
				label:"Publish the winners",
				target:'_blank',
				url:`${window.zendesk_base_url}115005737863/#5`,
			}, {
				key:'email_winners',
				label:"Send an email to the winners",
				url:getRemotedbUrl(`/emails/index/${promotion.id}`),
				enabled:(!is_basic) ? true : false,
			}, {
				key:'insights',
				label:"Check the promotion statistics",
				url:getRemotedbUrl(`/insights/${promotion.id}`),
				enabled:(!is_basic) ? true : false,
			}, {
				key:'export',
				label:"Export the list of participants",
				url:getRemotedbUrl(`/users/registered/${promotion.id}`, 'networks'),
			}, {
				key:'expired_page',
				label:"Edit the texts of the ''expired promotion'' page",
				url:getRemotedbUrl(`/promotions/builder/${promotion.id}`, 'expired_promo'),
				enabled:(!is_basic) ? true : false,
			}];
			break;

		case 'draft':
			to_do_actions = [{
				key:'template_instructions',
				label:"Template instructions",
				highlighted:true,
				action:(() => setDisplayInstructionsLayer(true)),
				enabled:(isNotEmpty(promotion, 'template_instructions')) ? true : false,
			}, {
				key:'tutorial',
				label:"Open and follow tutorial",
				target:'_blank',
				url:(promotionType) ? `${window.zendesk_base_url}${promotionType?.[`link_tutorial_${(window.is_spanish) ? 'es' : 'en'}`]}` : null,
			}, {
				key:'login_order',
				label:"Check the registration and participation order",
				url:getRemotedbUrl(`/promotions/builder/${promotion.id}`, 'login'),
				enabled:(is_multi_participation && is_multistage) ? true : false,
			}, {
				key:'prize',
				label:"Create the prize of the promotion",
				url:getRemotedbUrl(`/promotions/builder/${promotion.id}`, 'prizes'),
			}, {
				key:'design',
				label:"Customize the design of the layout",
				min_type:1,
				url:getRemotedbUrl(`/promotions/builder/${promotion.id}`, 'design'),
			}, {
				key:'share_contents',
				label:"Define the contents when Sharing",
				url:getRemotedbUrl(`/promotions/builder/${promotion.id}`, 'share'),
			}, {
				key:'networks',
				label:"Set up the social networks to follow",
				url:getRemotedbUrl(`/promotions/builder/${promotion.id}`, 'networks'),
			}, {
				key:'terms',
				label:"Review the terms and conditions",
				url:getRemotedbUrl(`/promotions/builder/${promotion.id}`, 'toc'),
			}, {
				key:'terms',
				label:"Review the privacy policy",
				url:getRemotedbUrl(`/promotions/builder/${promotion.id}`, 'policy'),
			}, {
				key:'emails',
				label:"Create automatic sending of emails",
				url:getRemotedbUrl(`/emails/index/${promotion.id}`),
				enabled:(!is_basic) ? true : false,
			}, {
				key:'dates',
				label:"Review the promotion dates",
				url:getRemotedbUrl(`/promotions/builder/${promotion.id}`, 'dates'),
			}, {
				key:'test',
				label:"Test and check before activating",
				target:'_blank',
				url:`${window.zendesk_base_url}360043826352`,
			}, {
				key:'activate',
				label:"Activate the promotion",
				url:getRemotedbUrl(`/promotions/payment/${promotion.id}`),
			}];
			break;
	}

	const getActionStatus = (key) => {
		if(progress_checkboxes[key] == undefined) return false;
		if(progress_checkboxes[key] == 'false') return false;
		if(progress_checkboxes[key] === false) return false;
		return true;
	};

	const toggleCheckbox = (key, display_response) => {
		if(display_response == undefined) display_response = true;

		const actual_status = (getActionStatus(key)) ? true : false;
		const _progress_checkboxes = { ...progress_checkboxes, [key]:!actual_status };
		setProgressCheckboxes(_progress_checkboxes);

		$.post(getRemotedbUrl(`/promotions/saveConfig/${promotion.id}`), { id:'progress', info:_progress_checkboxes }, (r) => {
			if(r.redirect_url != undefined) window.location.href = r.redirect_url;
			if(display_response) {
				(r?.status ?? true) ? EP.showSuccessSave() : EP.showErrorSave();
			}
		}, 'JSON');
	};

	if(to_do_actions.filter((t) => { return t?.enabled ?? true; }).length == 0) return null;

	return (
		<ProfileModule title={{ label:"To-do list", icon:'knk-on' }} style={{ '--main-bg-color':'255, 255, 160' }}>
			<ul class="gui_clean_listed_elements">
				{to_do_actions.map((t, i) => {
					const enabled = t?.enabled ?? true;
					if(!enabled) return null;

					let li_class = [];
					if(t.status) li_class.push('element_done');
					if(t.highlighted != undefined && t.highlighted) li_class.push('gui_force_bold');

					const status = (getActionStatus(t.key)) ? true : false;
					if (t.key == 'activate')
					return (
						<li key={i} class={li_class.join(" ")}>
							<div>
								<Checkbox
									name={t.key}
									change={() => toggleCheckbox(t.key)}
									value={status}
								>{t.label}</Checkbox>

								{(!status) ? (
									<ActivatePromoButton
										link_element={true}
										promotion={{ Promotion:promotion }}
										status={status}
										is_agent_admin={owner?.is_agent_admin ?? true}
										has_media={props?.has_media ?? false}
										organizer_id={owner?.organizer_id ?? false}
										has_available_subscription={props?.has_available_subscription ?? false}
										current_active={props?.current_active ?? 0}
										account_id={owner?.account?.id ?? false}
									>Do it now</ActivatePromoButton>
								) : (
									<ActionLink
										icon='knk-on'
										_class={{other:'gui_remove_pointer_events'}}
									>Done</ActionLink>
								)}
							</div>
						</li>
					)
					return (
						<li key={i} class={li_class.join(" ")}>
							<div>
								<Checkbox
									name={t.key}
									change={() => toggleCheckbox(t.key)}
									value={status}
								>{t.label}</Checkbox>

								{(!status) ? (
									<ActionLink
										_target={t.target}
										_href={t.url}
										onClick={(t.action != undefined) ? (() => t.action()) : null}
									>Do it now</ActionLink>
								) : (
									<ActionLink
										icon='knk-on'
										_class={{other:'gui_remove_pointer_events'}}
									>Done</ActionLink>
								)}
							</div>
						</li>
					)
				})}
			</ul>

			{(display_share_layer) && (
				<PromoShareLayer
					promotion={promotion}
					backButton={() => setDisplayShareLayer(false)}
				/>
			)}

			{(display_instructions_layer) && (
				<FloatingLayer backButton={() => setDisplayInstructionsLayer(false)}>
					<div class="without_actions">
						<SectionTitle>Instructions</SectionTitle>

						<div dangerouslySetInnerHTML={{ __html:promotion.template_instructions.replace(/\n/g, '<br />') }} />
					</div>
				</FloatingLayer>
			)}
		</ProfileModule>
	);
}

export default injectIntl(ToDoList);